<template>
  <div class="actions" v-if="order">
    <ProgressButton :class="['action', 'waiting', {'is-selected': order.state === 'waiting'}]" text="Väntar" :callback="changeState.bind(this, order.id, 'waiting')" />

    <ProgressButton :class="['action', 'cooking', {'is-selected': order.state === 'cooking'}]" text="Bakas" :callback="changeState.bind(this, order.id, 'cooking')" />

    <ProgressButton :class="['action', 'ready', {'is-selected': order.state === 'ready'}]" text="Klar" :callback="changeState.bind(this, order.id, 'ready')" />

    <ProgressButton :class="['action', 'completed', {'is-selected': order.state === 'completed'}]" text="Uthämtad" :callback="changeState.bind(this, order.id, 'completed')" />

    <ProgressButton :class="['action', 'destroy']" text="Makulera" :callback="destroy.bind(this, order.id)" />
  </div>
</template>

<script>
  import axios from 'lib/axios';
  import ProgressButton from 'components/progress-button';

  export default {
    name: 'OrderActions',
    components: { ProgressButton },
    props: {
      order: {
        type: Object,
        default: null
      }
    },

    methods: {
      async changeState (id, orderState) {
        let pursue = true;

        if (orderState === 'completed') {
          pursue = confirm('Markera som uthämtad?');
        }

        if (pursue) {
          await axios.put(`orders/${id}/state`, { id, orderState });
          await this.$store.commit('order/setState', { id, orderState });
        }
      },

      async destroy (id) {
        if (confirm('Är du säker?')) {
          await axios.delete('orders', { data: { id } });
          await this.$store.commit('order/destroy', id);
        }
      }
    }
  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo-admin'
  @require '~global/helpers'

  .actions
    display: flex

  .progress-button
    background: white
    color: $grey-dark
    border-color: $grey
    padding: 1.2rem
    line-height: 0
    margin-right: .3rem

  .progress-button:hover
    cursor: pointer

  .progress-button:hover,
  .progress-button.is-selected,
  .progress-button.is-active,
  .progress-button.is-active:hover
    background: $green
    color: $white
    border: 1px solid $green

 .progress-button.waiting.is-selected,
 .progress-button.waiting.is-active,
 .progress-button.waiting.is-active:hover
    background: $yellow
    border: 1px solid $yellow

  .progress-button.destroy,
  .progress-button.destroy.is-active,
  .progress-button.destroy.is-active:hover
    border: 1px solid $red
    margin-left: auto
    background: $red
    color: $white
</style>
